// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__1b8Gs","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__34kIK"};